module.exports = __webpack_public_path__ + "static/media/bgNoDots.e9392f7f.png";